import { Text } from 'mintel-react-ui';
import { mintelRed400 } from 'mintel-tokens';
import React from 'react';

import styles from './FieldErrors.scss';

const FieldErrors = ({
  errors,
  id,
}: {
  errors: string[];
  id?: string;
}): JSX.Element => (
  <div className={styles.error} id={id}>
    <Text.Body3 color={mintelRed400}>
      {errors.length > 1 ? (
        <ul>
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      ) : (
        errors[0]
      )}
    </Text.Body3>
  </div>
);

export default FieldErrors;
